import ScreenContainer from './ScreenContainer';
import { Branding } from '../common/Brand.jsx';
import { Box } from '@mui/material';
import { PropTypes } from 'prop-types';

export default function CondensedCenterContainer(props) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: '#d8d8d8',
        border: '1px none',
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        height: '100vh',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Branding placement={props.brandingPlacement} />
      {props.stepper}
      <ScreenContainer direction={props.direction} slideIn={props.slideIn} error={props.error}>
        {props.children}
      </ScreenContainer>
    </Box>
  );
}

CondensedCenterContainer.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.string,
  slideIn: PropTypes.bool,
  brandingPlacement: PropTypes.string,
  error: PropTypes.element,
  stepper: PropTypes.element,
};
